import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import ExamsTable from "./ExamsTable"
import LinkIcon from '@mui/icons-material/Link';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchToken } from '../../apiService';

const drawerWidth = 240;

export default function ClippedDrawer() {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [exam, setExam] = React.useState(1);
  const [open, setOpen] = React.useState(false);
  const [token, setToken] = React.useState("Fetching URL...");
  const [title, setTitle] = React.useState("");


  function handleClickOpen (tech){
    setToken("Fetching URL...")
    setTitle("Generated Link for " + tech + " exam !" );
    async function fetchData() {
     try {
      const tokenData = await fetchToken(tech);
      setToken(tokenData);
     } catch (error) {
     }
  }
    fetchData();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleListItemClick = (event, index,exam_id) => {
    setSelectedIndex(index);
    if(exam_id != null){
      setExam(exam_id);
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography variant="h6" noWrap component="div">
            AgileSparks Test Results
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
              <ListItem key="React" disablePadding>
                <ListItemButton selected={selectedIndex === 0}
                  onClick={(event) => handleListItemClick(event, 0,1)}> 
                  <ListItemIcon>
                    <img src="icons/react.png" width="24px" height="24px"/>
                  </ListItemIcon>
                  <ListItemText primary="React" />
                  <IconButton aria-label="generate link" onClick={() => handleClickOpen("react")}>
                  <LinkIcon/>
                </IconButton>     
                </ListItemButton>           
              </ListItem>
              <ListItem key="Fullstack" disablePadding>
                <ListItemButton selected={selectedIndex === 1}
                  onClick={(event) => handleListItemClick(event, 1,2)}>
                  <ListItemIcon>
                    <img width="24px" height="24px" src="icons/fullstack.png"/>
                  </ListItemIcon>
                  <ListItemText primary="Fullstack" />
                  <IconButton aria-label="generate link" onClick={() => handleClickOpen("fullstack")}>
                  <LinkIcon/>
                </IconButton>     
                </ListItemButton>
              </ListItem>
          </List>
          <Divider />
          <List>
          
              <ListItem key="Python" disablePadding>
                <ListItemButton selected={selectedIndex === 2}
                  onClick={(event) => handleListItemClick(event, 2,3)}>
                  <ListItemIcon>
                    <img width="24px" height="24px" src="icons/python.png"/>
                  </ListItemIcon>
                  <ListItemText primary="Python" />
                  <IconButton aria-label="generate link" onClick={() => handleClickOpen("python")}>
                  <LinkIcon/>
                </IconButton>     
                </ListItemButton>
              </ListItem>
              <ListItem key="Java" disablePadding>
                <ListItemButton selected={selectedIndex === 3}
                  onClick={(event) => handleListItemClick(event, 3,4)}>
                  <ListItemIcon>
                    <img width="24px" height="24px" src="icons/java.png"/>
                  </ListItemIcon>
                  <ListItemText primary="Java" />
                  <IconButton aria-label="generate link" onClick={() => handleClickOpen("java")}>
                  <LinkIcon/>
                </IconButton>     
                </ListItemButton>        
                </ListItem>
                <ListItem key="DevOps" disablePadding>
                <ListItemButton selected={selectedIndex === 4}
                  onClick={(event) => handleListItemClick(event, 4,5)}>
                  <ListItemIcon>
                    <img width="24px" height="24px" src="icons/devops.png"/>
                  </ListItemIcon>
                  <ListItemText primary="DevOps" />
                  <IconButton aria-label="generate link" onClick={() => handleClickOpen("devops")}>
                  <LinkIcon/>
                </IconButton>     
                </ListItemButton>        
              </ListItem>
              <ListItem key="Golang" disablePadding>
                <ListItemButton selected={selectedIndex === 5}
                  onClick={(event) => handleListItemClick(event, 5,6)}>
                  <ListItemIcon>
                    <img width="24px" height="24px" src="icons/golang.png"/>
                  </ListItemIcon>
                  <ListItemText primary="Golang" />
                  <IconButton aria-label="generate link" onClick={() => handleClickOpen("golang")}>
                  <LinkIcon/>
                </IconButton>     
                </ListItemButton>        
              </ListItem>
          </List>
        </Box>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <ExamsTable exam_id={exam}></ExamsTable>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <Typography >
            <div style={{width:"400px",height:"300",overflowWrap:'break-word'}}>{token}</div>
          </Typography >
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}